<template>
  <div class="approved-feedback">
    <AnimationCheck />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AnimationCheck from '@/components/common/AnimationCheck.vue';

export default {
  name: 'checkout-approved-feedback',
  components: {
    AnimationCheck,
  },
  computed: {
    ...mapState('checkout', [
      'hasGracePeriod',
    ]),
  },
  methods: {
    ...mapActions('checkout', [
      'goToPage',
    ]),
  },
  mounted() {
    setTimeout(() => {
      this.goToPage(`checkout-approved${this.hasGracePeriod ? '-grace' : ''}`);
    }, 1800);
  },
};
</script>

<style lang="scss" scoped>
.approved-feedback {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  text-align: center;
  padding: 20px;
}

.approved-feedback-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 15px;
}

.approved-feedback-title {
  @extend .h2;
  @extend .gray-600;
  margin-bottom: 8px;
}

.approved-feedback-subtitle {
  @extend .body-regular;
  @extend .gray-400;
}

</style>
